import React from 'react';
import StoreListener from '../store/StoreListener';
import { GLOBAL_PROGRESS } from '../store/Constants';
import { LoaderSpinner } from './Spinner';

const storeItems = [GLOBAL_PROGRESS];

@StoreListener(storeItems)
export default class InfiniteProgress extends React.Component {
  state = { active: false, loader: false };
  componentWillMount() {
    window.gs.setProgress = this.setProgress;
  }

  componentDidUpdate() {
    if(window.gs.setProgress !== this.setProgress) {
      window.gs.setProgress = this.setProgress;
    }
  }

  setProgress = (isActive = false, isLoader = false) => {
    this.setState({ active: isActive, loader: isLoader });
  };

  render() {
    const { active, loader } = this.state;
    return (
      <React.Fragment>
        {active ? (
          <div style={styles.progress}>
            <svg style={{ position: 'absolute' }} width="100%" height="2.5px">
              <rect height="100%" fill="var(--primary-style-color)">
                <animate attributeName="width" from="0px" to="100%" begin="0" dur="5" repeatCount="indefinite" />
              </rect>
            </svg>
          </div>
        ) : null}
        {loader ? <LoaderSpinner /> : null}
      </React.Fragment>
    );
  }
}

const styles = {
  progress: {
    position: 'fixed',
    top: '0',
    left: '0',
    height: '2.5px',
    width: '100%',
    zIndex: '1',
    cursor: 'wait'
  }
};
